module.exports = __webpack_public_path__ + "img/IL.117eb777.svg";